import { useContext, type FC } from 'react';
import './realized-and-implied-vols-styles.scss';
import InlineOptions from '../../inline-options';
import {
  FrequencyTypeEnum,
  TokenVolatilityTimeseriesContext,
  VenueTypeEnum,
  VolatilityTypeEnum,
} from '../../../../providers/token-volatility-timeseries-provider';
import { RangeOptions } from '../../constants/volatility-options';
import { RangeEnum } from '../../../../model/range.enum';
import AddRealizedSeries from './add-realized-series';
import RealizedAndImpliedChart from './realized-and-implied-chart';

const RealizedAndImpliedVolsContent: FC = () => {
  const { range, setRange, addSeries, seriesExists } = useContext(TokenVolatilityTimeseriesContext);

  const handleApply = (options: Record<string, any>) => {
    if (options.volatility === VolatilityTypeEnum.REALIZED) {
      addSeries(
        options.token,
        options.window,
        VolatilityTypeEnum.REALIZED,
        options.frequency,
        options.venue,
      );
    } else {
      addSeries(
        options.token,
        options.tenor,
        VolatilityTypeEnum.IMPLIED,
        FrequencyTypeEnum.hour1,
        VenueTypeEnum.DERIBIT,
      );
    }
  };

  const renderInlineOptions = () => (
    <div className="realized-and-implied-vols-header">
      <InlineOptions
        options={RangeOptions}
        selectedOption={range}
        onOptionChange={(val) => {
          if (Array.isArray(val) && val.length) {
            setRange(val[0] as RangeEnum);
            return;
          }

          setRange(val as RangeEnum);
        }}
        maxVisibleOptions={10}
      />
      <AddRealizedSeries onApply={handleApply} seriesExists={seriesExists} />
    </div>
  );

  return (
    <div className="realized-and-implied-vols-content">
      {renderInlineOptions()}
      <RealizedAndImpliedChart />
    </div>
  );
};

export default RealizedAndImpliedVolsContent;
